<template>
  <div class="attachment-upload">
    <div class="sub-header">Upload Attachments</div>
    <DragNDropPad
      :reference-number="referenceNumber"
      :owner="owner"
      :category="category"
      @attachment-success="$emit('attachment-success')"
    />
  </div>
</template>

<script>
import DragNDropPad from './DragNDropPad';

export default {
  name: 'Attachment',
  components: {
    DragNDropPad
  },
  props: {
    referenceNumber: {
      type: String,
      required: true
    },
    owner: {
      type: String,
      required: true
    },
    category: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../styles/colors.scss';
@import '../../styles/variables.scss';

.attachment-upload {
  background-color: $background-level-2;
  padding: $details-padding;

  > .sub-header {
    margin-bottom: 10px;
  }
}

@media print {
  .attachment-upload {
    display: none;
  }
}

@media only screen and (max-width: 768px) {
  * {
    font-size: 0.8rem;
  }
  .attachment-upload {
    padding: $responsive-details-padding;
  }
}
</style>
